import AlertComponent from './AlertComponent';
export * from './AlertComponent';
export default AlertComponent;
